module.exports = __webpack_public_path__ + "static/img/YB-25Vs.53adeb82.png";